import {component, EntityData, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {AccountSearchData} from "./account-search.data";

export class AccountDetailsReferenceData extends EntityData<AccountDetailsReferenceData> {
    @field accountNo: number;
    @field accountName: string;
}

export class AccountReferenceData extends LocalisableEntityData<AccountReferenceData> {
    @identifier accountId: string;
    @component details: AccountDetailsReferenceData;

    static fromAccountSearchData(accountSearchData: AccountSearchData): AccountReferenceData {
        const accountReferenceData: AccountReferenceData = <AccountReferenceData>EntityData.create(AccountReferenceData);
        accountReferenceData.accountId = accountSearchData.accountId;
        accountReferenceData.details.accountName = accountSearchData.accountName;
        return accountReferenceData
    }
}
